// extracted by mini-css-extract-plugin
export default {"tabRoot":"tabs_tabRoot__1-KLh","tabWrapper":"tabs_tabWrapper__6oypN"};